module.exports = __webpack_public_path__ + "static/media/portalin.2aa6b26c.png";